// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"e4a3b0cd","829":"ea844eac","888":"43c8e373"}[chunkId] + ".chunk.js";
};